<script>
import { mapGetters, mapState } from "vuex";

import professionalMixin from "@/mixins/accountable/professionalMixin";
import addressMixin from "@/mixins/addressMixin";
import dateMixin from "@/mixins/dateMixin";
import currencyMixin from "@/mixins/generic/currencyMixin";

import pricingHelper from "@/utils/helpers/pricingHelper";
import couponHelper from "@/utils/helpers/coupon";

import Star from "@/components/_base/Star";

export default {
  mixins: [professionalMixin, addressMixin, dateMixin, currencyMixin],

  components: {
    Star
  },

  methods: {
    totalOrders() {
      return this.$options.filters.orderCount(this.professional);
    }
  },

  computed: {
    ...mapState("orderScheduler", ["description", "shouldIncludeProducts"]),
    ...mapGetters("orderScheduler", [
      "date",
      "initialHour",
      "duration",
      "professional",
      "address"
    ]),
    ...mapState("requireProductsPreference", ["productsPricing"]),

    pricing: function() {
      return pricingHelper.calculatePricing(
        this.address,
        this.duration,
        this.shouldIncludeProducts,
        this.productsPricing || null
      );
    },

    pricingWithDiscount: function() {
      if (!this.professional || !this.professional.active_coupon) {
        return null;
      }

      return couponHelper.applyDiscount(
        this.pricing,
        this.professional.active_coupon
      );
    }
  }
};
</script>

<template>
  <div class="confirmation">
    <div class="professional">
      <span class="header">Limpeza com o(a) Profissional</span>

      <div class="professional-info">
        <img class="profile-picture" :src="professional | profilePicture" />

        <div class="infos">
          <div class="name">
            <span>{{ professional | shorterFullName }}</span>

            <div class="rating">
              <Star />

              <span class="rating-number">
                {{ professional | rating }} <span class="feedback-count" v-if="professional.total_feedbacks_count > 3">({{ professional | feedbacks }})</span>
              </span>
            </div>
          </div>

          <div class="orders-count">
            {{ totalOrders() > 0 ? `${totalOrders()} limpezas  realizadas` : 'Novo(a) profissional' }}
          </div>
        </div>
      </div>
    </div>

    <div class="order-infos">
      <span class="header">Detalhes do agendamento</span>

      <div class="when">
        <div class="info-item">
          <span>
            <b>Dia {{ date | formatDate("DD/MM/YYYY") }} ({{ date | weekday }})</b>
          </span>

          <span>
            Iniciando às <b>{{ initialHour }}h</b> com uma duração de <b>{{ duration }}h.</b>
          </span>
        </div>

        <div class="info-item">
          <span>
            No endereço <b>{{ address | name }}</b>
          </span>
          <span>{{ address | streetAddress }}</span>
        </div>

        <div class="description">
          <span>{{ description || 'Nenhuma descrição da limpeza informada!' }}</span>
        </div>
      </div>
    </div>

    <div class="total" v-if="pricingWithDiscount">
      <div>
        <span class="subtotal-text">Subtotal</span>
        <span class="subtotal-pricing">{{ pricing | toCurrency }}</span>
      </div>

      <div>
        <span class="text">Total (com desconto)</span>
        <span class="pricing">{{ pricingWithDiscount | toCurrency }}</span>
      </div>
    </div>

    <div class="total" v-else>
      <div>
        <span class="text">Total</span>
        <span class="pricing">{{ pricing | toCurrency }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.confirmation {
  border: solid 1px #e2e2e2;
  border-radius: 2px;
  padding: 8px 12px;
}

.professional,
.order-infos {
  padding-bottom: 8px;
  border-bottom: solid 1px #e2e2e2;
}

.professional-info {
  width: 100%;
  margin-top: 8px;
  display: flex;
  align-items: center;
}

.profile-picture {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.infos {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-left: 12px;
}

.name {
  display: flex;
  color: #424242;
  font-size: 15px;
  font-weight: 400;
  align-items: center;
}

.rating {
  display: flex;
  font-size: 14px;
}

.rating > .rating-number {
  font-weight: 300;
  font-size: 14px;
  font-weight: 400;
  margin-left: 4px;
  padding-left: 4px;
  display: flex;
  align-items: center;
  border-left: solid 1px #ddd;
}

.orders-count {
  font-size: 13px;
}

.orders-count span {
  font-weight: 400;
  color: #603285;
}

.order-infos {
  padding: 8px 0;
}

.info-item {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  margin-left: 8px;
  padding-left: 8px;
  border-left: solid 2px #e2e2e2;
}

.info-item span {
  font-size: 13px;
}

.description {
  margin-top: 16px;
  font-style: italic;
  font-size: 13px;
}

.total {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 8px;
}

.total > div {
  display: flex;
  justify-content: space-between;
  padding-top: 8px;
}

.total .subtotal-pricing {
  color: #424242;
  font-weight: 500;
  font-size: 14px;
}

.total .subtotal-text {
  color: #424242;
  font-weight: 400;
  font-size: 14px;
}

.total .text {
  font-weight: 400;
  color: #424242;
}

.total .pricing {
  color: #af006b;
  font-weight: 500;
}

.header {
  font-size: 13px;
  color: #888;
  font-weight: 300;
}

b {
  font-weight: 500;
}
.feedback-count {
  margin-left: 4px;
}

@media (max-width: 375px) {
  .feedback-count {
    /* display: none; */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Confirmation/OrderReview.vue